export const ToastOptions = {
  closeButton: true, // you can override any options available here https://www.npmjs.com/package/ngx-toastr
  newestOnTop: true,
  autoDismiss: true,
  enableHtml: true,
  timeOut: 5000,
  tapToDismiss: false,
  preventDuplicates: true
};
